import { Table, TableBody } from '@mui/material';
import {
  Control,
  FieldArray,
  FieldErrors,
  UseFormRegister,
} from 'react-hook-form';

import { TourEventsFormValues } from '../tour-event-form-values/TourEventsFormValues';
import { AddTourEventsTableBodyRow } from './AddTourEventsTableBodyRow';
import { AddTourEventsTableHeader } from './AddTourEventsTableHeader';
import { AddTourEventsTableLastRow } from './AddTourEventsTableLastRow';

export function AddTourEventsTable({
  control,
  register,
  fields,
  errors,
  onClickAddTourEvent,
  onClickDeleteTourEvent,
}: {
  control: Control<TourEventsFormValues>;
  register: UseFormRegister<TourEventsFormValues>;
  fields: Array<FieldArray<TourEventsFormValues, 'tourEvents'>>;
  errors: FieldErrors<TourEventsFormValues>;
  onClickAddTourEvent: () => void;
  onClickDeleteTourEvent: (index: number) => void;
}) {
  return (
    <Table>
      <AddTourEventsTableHeader />
      <TableBody>
        {fields.map((field, index) => (
          <AddTourEventsTableBodyRow
            key={index + Math.random()}
            index={index}
            field={field}
            control={control}
            register={register}
            errors={errors}
            onClickDelete={() => onClickDeleteTourEvent(index)}
          />
        ))}
        <AddTourEventsTableLastRow onClickAddTourEvent={onClickAddTourEvent} />
      </TableBody>
    </Table>
  );
}
